import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal, Kicker, SectionTitle } from "./motion";

const QA = [
  ["Eu posso mesmo revender os materiais?", "Sim. Os dois planos vêm com licença PLR para revenda, e junto com o acesso você recebe o termo de licença com tudo o que é permitido fazer. No Premium, você ainda recebe kits prontos para revenda e 3 bônus para divulgar."],
  ["Qual plano devo escolher?", "Os dois têm licença de revenda. Mas se o seu objetivo é começar a vender rápido, o Premium: ele já vem com kits prontos para revenda, os 3 bônus (Pack Canva, Guia para Revender PLR e Pack de Artes para Divulgação) e suporte via WhatsApp, por pouco mais que o Básico."],
  ["Por quanto posso vender?", "Você define o seu preço. Muitas pessoas montam kits temáticos (alfabetização, datas comemorativas, matemática) e vendem cada um separadamente."],
  ["Onde posso vender?", "Pela internet: Instagram, Facebook, TikTok, grupos de WhatsApp e marketplaces de produtos digitais, ou diretamente para escolas, creches e famílias da sua região."],
  ["Como recebo o acesso depois de comprar?", "Por e-mail, em poucos minutos após a confirmação do pagamento (PIX ou cartão). Se não encontrar, confira também a caixa de spam e a aba Promoções."],
  ["Tem mensalidade?", "Não. É pagamento único, com acesso vitalício e sem data para expirar."],
];

export const Faq = () => (
  <section className="bg-lilac py-20 sm:py-28" data-testid="faq-section">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 lg:grid-cols-12">
      <Reveal className="lg:col-span-5">
        <Kicker>Dúvidas</Kicker>
        <SectionTitle className="mt-5 text-ink">Ainda ficou <span className="text-plum">alguma pergunta?</span></SectionTitle>
      </Reveal>
      <Reveal className="lg:col-span-7" delay={0.1}>
        <Accordion type="single" collapsible className="space-y-3">
          {QA.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="rounded-[22px] border-0 bg-white px-6" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-display text-base font-bold text-ink hover:no-underline sm:text-lg" data-testid={`faq-trigger-${i}`}>{q}</AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-ink/75">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
